import { render, staticRenderFns } from "./AddPrescription.vue?vue&type=template&id=0ef12e9a&scoped=true"
import script from "./AddPrescription.vue?vue&type=script&lang=js"
export * from "./AddPrescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef12e9a",
  null
  
)

export default component.exports